import React from "react";
import { SurveyTempalte } from "../../Templates/SurveyTemplate";

export const Survey = () => {
  return <SurveyTempalte />;
};
